import { isAppleWalletSupported } from '../subcomponents/apple-wallet/utils';
import { isGooglePaySupported } from '../subcomponents/google-pay/utils';
import { JourneyActionButtonType as ButtonType } from '../types/type';
export const isButtonSupported = (type) => {
    switch (type) {
        case ButtonType.AppleWallet:
            return isAppleWalletSupported();
        case ButtonType.GooglePay:
            return isGooglePaySupported();
        default:
            return true;
    }
};
